import {appsettings} from "../AppSettings"


export default class ConfigService
{
    constructor()
    {
        this.appsettings = appsettings;
    }


    hasKey(key){
        return this.appsettings.some(o => o.key === key);
    }

    getValue(key){
        let obj = this.appsettings.find(o => o.key === key);
        return obj.value;
    }

    getAppVersion()
    {
        return this.getValue("version");
    }

    getAuthServiceHost()
    {
        return this.getValue("glasschain.auth.host.addr");
    }

    getMsaCoreServiceHost()
    {
        return this.getValue("glasschain.msa.core.host.addr");
    }

    getOrgCoreServiceHost()
    {
        return this.getValue("glasschain.org.core.host.addr");
    }

    getNotificationServiceHost()
    {
        return this.getValue("glasschain.notification.host.addr");
    }

    getNotificationDirectTemplateId()
    {
        return this.getValue("glasschain.notification.direct.template.id");
    }

    getNotificationAlertTemplateId()
    {
        return this.getValue("glasschain.notification.alert.template.id");
    }

    getUserScope()
    {
        return this.getValue("user.scope");
    }



    getBlobStorageAccount()
    {
        return this.getValue("glasschain.obs.storage.account.blob");
    }

    getObservationImageBase()
    {
        return this.getValue("glasschain.obs.image.store.addr");
    }

    getCustomerLogoImagePath(gcid)
    {
        var result = this.getObservationImageBase() +"/" + gcid + "/logos/" + gcid + "-logo.png";
        return result;
    }

    getGoogleVisionServiceHost()
    {
        return this.getValue("google.vision.api.host.addr");
    }

    getGoogleVisionApiKey()
    {
        return this.getValue("google.vision.api.key");
    }

    getReceiptStatusInterval()
    {
        return this.getValue("receipt.status.poller.interval");
    }

    getMraTagMaxLength()
    {
        return this.getValue("receipt.mratag.maxlength");
    }

}